let generation = 0;
export const beginPositionRead = () => ++generation;
export const isCurrentPositionRead = value => value === generation;
